<template v-slot:header >
  <v-app>
    <nav>
      <!-- Primera seccion -->
      <v-toolbar flat app color="secondary" text-xs-center height="34px" class="hidden-sm-and-down">
        <v-spacer></v-spacer>
        <div class="mt-4">
          <p text small class="subtitle-2 white--text">{{$t('localeCaption')}}</p>
        </div>
        <div class="my-2">
          <v-btn text small class="white--text" v-on:click="shiftLocale">{{$t('languaje')}}</v-btn>
        </div>
      </v-toolbar>
      <!-- Segunda seccion -->
      <v-toolbar flat app color="primary" height="70px" class="hidden-sm-and-down">
        <img class="mr-4" :src="require('@/assets/main_logo_w.png')" height="40"/>
        <v-toolbar-title class="white--text">TSMX Digital | {{$t('tittle')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-title class="white--text">{{ userData.name }}</v-toolbar-title>
       
      </v-toolbar>
      <!-- Tercera seccion -->
      <v-toolbar height="60px" class="hidden-sm-and-down">
        <router-link router :to="option" v-for="(option, i) in options" :key="i">
          <v-btn text medium>{{$t(option.name)}}</v-btn>
        </router-link>
        <v-spacer></v-spacer>
        <v-btn text large class="ma-2 ml-15" @click="signOut" @click.stop="signOut()">
          <v-icon>mdi-logout</v-icon>
          {{$t('logoff')}}
        </v-btn>
      </v-toolbar>
      <v-toolbar color="primary" class="hidden-md-and-up" app>
        <img class="mr-4" :src="require('@/assets/main_logo_w.png')" height="40"/>
        <v-spacer></v-spacer>
        <v-app-bar-nav-icon class="white--text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      </v-toolbar>
      <v-navigation-drawer app v-model="drawer" temporary>
        <v-list>
          <v-subheader>MENU</v-subheader>
          <v-list-item router :to="option" v-for="(option, i) in options" :key="i">
              <v-list-item-group v-if="option.name == 'meetingRooms'">
              <v-list-item-content>
                <v-list-item-title>{{$t(option.name)}}</v-list-item-title>
              </v-list-item-content>
              <v-list-item router :to="option" v-for="(option, i) in submenu" :key="i">
              <v-list-item-group v-if="option.name == 'meetingRooms'">
              <v-list-item-content>
                <v-list-item-title>{{$t(option.name)}}</v-list-item-title>
              </v-list-item-content>
              </v-list-item-group>
              <v-list-item-group v-else>
              <v-list-item-content>
                <v-list-item-title>{{$t(option.name)}}</v-list-item-title>
              </v-list-item-content>
              </v-list-item-group>
          </v-list-item>
              </v-list-item-group>
              <v-list-item-group v-else>
              <v-list-item-content>
                <v-list-item-title>{{$t(option.name)}}</v-list-item-title>
              </v-list-item-content>
              </v-list-item-group>
          </v-list-item>
          <v-subheader>{{$t('localeCaption')}}</v-subheader>
          <v-list-item link v-on:click="shiftLocale">
            <v-list-item-icon>
              <v-icon></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{$t('languaje')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <!-- Primera seccion -->
    </nav>

    <v-container fluid class="content-top">
      <slot name="content"></slot>
    </v-container>

    <v-footer app color="primary" class="white--text">
      <span>T-Systems México</span>
      <v-spacer />
      <span>versión {{ appVersion }}</span>
    </v-footer>
  </v-app>
</template>


<script>
import i18nMessages from "./i18n/members.messages";
import { mapGetters } from "vuex";
import { Auth } from "aws-amplify";

var self = null;

export default {
  props: {
    showHelp: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.$i18n.locale = this.locale;
    Auth.currentAuthenticatedUser().then(data => {
      // Obtiene el email de usuario
      let email = data.signInUserSession.idToken.payload.email;
      let settings = {
        email: email
      };
      this.$GET('/api/users/email/{{email}}', settings)
        .then(user => {
          this.$store.dispatch("setUserProfile", { userProfile: user }).then(() => {
            
            this.userData = {
              name: user.name,
              shortName: 'XX'
            }   
            
            // Validacion de menu
            this.$router.options.routes.forEach(route => {
              let userProfiles = this.$store.getters["roles"];
              if (route.showInMenu && route.children == null && route.meta.roles.find((r) => r === "*" || userProfiles.find((element) => element === r))) {
                this.options.push({
                  to: route,
                  icon: route.icon,
                  name: route.name,
                  children: route.children
                });
              } else if (route.showInMenu && route.children != null && route.meta.roles.find((r) => r === "*" || userProfiles.find((element) => element === r))) {
                this.submenu.push({
                  to: route,
                  icon: route.icon,
                  name: route.name,
                  children: route.children
                });
              }
            });
          });
          
        })
        .catch(e => {
          // El usuario no existe
          console.log(e);
          console.log('AttachProfile: El usuario no existe')
        });
    });
    console.log(`UserData: `, this.userData);
  },
  beforeDestroy() {},
  i18n: i18nMessages,
  data() {
    //
    var userData = {};
    var submenu = [];
    var options = [];

    self = this;
    return {
      isHelpDrawerVisible: false,
      isMenuDrawerVisible: false,
      options: options,
      submenu: submenu,
      drawer: false,
      group: null,
      userData: userData
    };
  },
  methods: {
    shiftLocale() {
      //** console.log("shiftLocale");
      this.$store.dispatch("shiftLocale");
    },
    signOut() {
      this.$store.dispatch("signOut").then(()=> {
         self.navigateToSingin();
      });
    },
    navigateToSingin() {
       window.location.reload(true);
    },
    toggleMenu() {
      this.isMenuDrawerVisible = !this.isMenuDrawerVisible;
    }
  },
  computed: {
    ...mapGetters(["isSignedIn"]),
    locale() {
      return this.$store.getters["locale"];
    },
    user() {
      return this.$store.getters["user"];
    },
    appVersion() {
      return process.env.VUE_APP_VERSION || "0.0.0";
    },
  },
  watch: {
    locale(value) {
      this.$i18n.locale = value;
    },
    isLoggedIn: isLoggedInValue => {
      if (!isLoggedInValue) {
        self.navigateToSingin();
      }
    },
    group() {
      this.drawer = false;
    }
  }
};
</script>

<style >
a {
  text-decoration: none;
}
</style>
